import styled from "styled-components"


const PanelCurrencyName = styled.div`
    color: #888;
    background-color: inherited;
    pointer-events: auto;
    font-size: 0.6em;
    margin: 0, auto;
    text-align: left;
    align-self: left;
`;

export default PanelCurrencyName;

